//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import lodash from "lodash";
import VueGridLayout from "vue-grid-layout";
import { eventEmitter } from "@/main.js";

export default {
	name: "dashboard",
	components: {
		GridLayout: VueGridLayout.GridLayout,
		GridItem: VueGridLayout.GridItem,
	},

	data: () => ({
		loading: true,
		data: [],
	}),
	computed: {
		...mapGetters([
			"getMarketsFavs",
			"getWalletsFavs",
			"getToken",
			"getDashboard",
		]),
	},
	async created() {
		this.debounce = lodash.debounce(this.dashboardResize, 5000);
		this.loading = true;
		await this.fetchDashboard();
		await this.fetchMarketsFavs();
		await this.fetchData();
		this.loading = false;
	},
	methods: {
		switchTheme() {
			switchTheme();
		},
		async dashboardResize(val) {
			await this.syncDashboard();
		},
		redirect(path) {
			this.$router.push(path);
		},
		async addTile() {
			eventEmitter.$emit("add-tile", {
				marketsFavorites: this.getMarketsFavs,
				walletsFavorites: this.getWalletsFavs,
			});
		},
		...mapActions([
			"globalMetrics",
			"fetchMarketsFavs",
			"fetchWalletsFavs",
			"syncDashboard",
			"fetchDashboard",
			"getUid",
		]),

		async fetchData() {
			try {
				this.loading = true;
				const { market_cap_percentage: data } = await this.globalMetrics();
				this.data = data;
			} catch (e) {
				this.loading = false;
				console.warn("Error while executing Global metrics request", e);
			}
		},
	},
};
